require("@novaescola/eva-react-v2/lib/globals.css");
